import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 销售计划历史数据查询
 * @param {*} params
 */
export function findSalePlanHistory(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findSaleplanHistoryQuery',
    method: 'post',
    data
  })
}
/**
 * 销售计划存货分类查询
 * @param {*} params
 */
export function findchflList(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findchflList',
    method: 'post',
    data
  })
}
/**
 * 销售计划计划类型查询
 * @param {*} params
 */
export function findnewPlanTypeList(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findnewPlanTypeList',
    method: 'post',
    data
  })
}
/**
 * 按客户和存货分类查询 历史计划量接口
 * @param {*} params
 */
export function findSaleplanHistory(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findSaleplanHistory',
    method: 'post',
    data
  })
}
/**
 * 查询合同区域
 * @param {*} params
 */
export function findContractArea(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findContractArea',
    method: 'post',
    data
  })
}
/**
 * 查询合同渠道
 * @param {*} params
 */
export function findContractChannel(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findContractChannel',
    method: 'post',
    data
  })
}
/**
 * 查询单价
 * @param {*} params
 */
export function findBrandPrice(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findBrandPrice',
    method: 'post',
    data
  })
}
/**
 *生成OA文件附件并上传服务器
 * @param {*} params
 */
export function getSendOAFiles(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/getSendOAFiles',
    method: 'post',
    data
  })
}
/**
 *列表获取审批提示文案
 * @param {*} params
 */
 export function getSaleCenerSignCompleted(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/getSaleCenerSignCompleted',
    method: 'post',
    data
  })
}
/**
 *签约列表明细
 * @param {*} params
 */
 export function findSignCompletedDetail(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findSignCompletedDetail',
    method: 'post',
    params: data
  })
}
/**
 *签约完成情况列表
 * @param {*} params
 */
 export function findSignCompletedQuery(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findSignCompletedQuery',
    method: 'post',
    data
  })
}
/**
 *签约完成情况列表查询
 * @param {*} params
 */
 export function findSignCompletedDetailQuery(data) {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/findSignCompletedDetailQuery',
    method: 'post',
    data
  })
}
/**
 *是否导入建议签约量
 * @param {*} params
 */
 export function getSignImportLimit() {
  return request({
    url: BASE_API() + '/ztcrmSaleplan/getSignImportLimit',
    method: 'post',
  })
}
// 经销商分流任意客户查询
export function findShuntAnyClientsQuery(data) {
  return request({
    url: BASE_API() + '/setShunting/findShuntAnyClientsQuery',
    method: 'post',
    data
  })
}
// 保存分流任意客户的设置   
export function saveShuntAnyClient(data) {
  return request({
    url: BASE_API() + '/setShunting/saveShuntAnyClient',
    method: 'post',
    data
  })
}
// 删除分流任意客户的设置 
export function deleShuntAnyClient(data) {
  return request({
    url: BASE_API() + '/setShunting/deleShuntAnyClient',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/signing.js